import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Link } from "react-router-dom";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

function Row(props) {
  const {
    row,
    handleOrderProdsNotes,
    status,
    handleUpdateStatus,
    couriersList,
    handleUpdateCourier,
    handleUpdateTracking,
  } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell align="left">{row.productName}</TableCell>
        <TableCell align="left">{row.quantity}</TableCell>
        <TableCell align="left">{row.totalPoints}</TableCell>
        <TableCell align="left">{row.createdAt.split("T")[0]}</TableCell>
        <TableCell align="left">{row.updatedAt.split("T")[0]}</TableCell>
        <TableCell align="left">
          {row.courierTrackingURL && row.courierTrackingID && (
            <Link to={{ pathname: row.courierTrackingURL }} target="_blank">
              View Tracking
            </Link>
          )}
        </TableCell>

        <TableCell style={{ width: 150 }}>
          <div>
            <FormControl style={{ width: 150 }} margin="dense">
              <Select
                variant="outlined"
                defaultValue={row.statusID}
                margin="dense"
                onChange={(e) => handleUpdateStatus(e, row.productID)}
                inputProps={{
                  name: "status",
                  id: "status-simple",
                }}
              >
                {[
                  // {id: 1, value: 'Active', name: 'Active'},
                  {
                    id: 5,
                    value: "Pending",
                    name: "Pending",
                    isDisabled: true,
                  },
                  { id: 16, value: "Dispatched", name: "Dispatched" },
                  { id: 23, value: "Refunded", name: "Refunded" },
                  {
                    id: 24,
                    value: "Processing",
                    name: "Processing",
                    // isDisabled: true,
                  },
                  { id: 9, value: "Completed", name: "Completed" },
                ].map((status) => (
                  <option value={status.id} disabled={status.isDisabled}>
                    {status.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </div>
        </TableCell>

        {/* <TableCell align="left">
          <button onClick={(e) => handleRemove(e, row.productID)}>
            Remove
          </button>
        </TableCell> */}
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <TableCell>
              <div
                style={{
                  fontSize: 14,
                  fontWeight: "bold",
                  color: "rgb(64, 132, 243)",
                }}
              >
                Courier + Tracking
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: 20,
                }}
              >
                <div style={{ display: "flex" }}>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    Courier Company
                    <TableCell>
                      <FormControl style={{ width: 150 }} margin="dense">
                        <Select
                          variant="outlined"
                          defaultValue={row.courierCompanyID}
                          margin="dense"
                          onChange={(e) =>
                            handleUpdateCourier(e, row.productID)
                          }
                          inputProps={{
                            name: "status",
                            id: "status-simple",
                          }}
                        >
                          <option value={null}>N/A</option>
                          {couriersList &&
                            couriersList.map((courier) => (
                              <option
                                value={courier.id}
                                disabled={courier.isDisabled}
                              >
                                {courier.name}
                              </option>
                            ))}
                        </Select>
                      </FormControl>
                    </TableCell>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    Tracking ID
                    <TableCell>
                      <div style={{ width: "100%" }}>
                        <TextField
                          size="small"
                          minRows={3}
                          // multiline
                          defaultValue={
                            row.courierTrackingID ? row.courierTrackingID : ""
                          }
                          className={classes.textItem}
                          variant="outlined"
                          margin="dense"
                          id="notes"
                          type="text"
                          fullWidth
                          onChange={(e) =>
                            handleUpdateTracking(e, row.productID)
                          }
                          // style={{border: }}
                        />
                      </div>
                    </TableCell>
                  </div>
                </div>
              </div>
            </TableCell>
            {row.purchaseOrderID && (
              <TableCell>
                <Link
                  to={`/purchase-orders?purchaseOrder=${row.purchaseOrderID}`}
                >
                  View Purchase Order
                </Link>
              </TableCell>
            )}
            <Box margin={1}>
              <Typography variant="subtitle2" gutterBottom component="div">
                Notes
              </Typography>
              <div style={{ width: "100%" }}>
                <TextField
                  size="small"
                  minRows={3}
                  multiline
                  defaultValue={row.notes ? row.notes : ""}
                  className={classes.textItem}
                  variant="outlined"
                  margin="dense"
                  id="notes"
                  type="text"
                  fullWidth
                  onChange={(e) => handleOrderProdsNotes(e, row.productID)}
                  // style={{border: }}
                />
              </div>
              {/* <Typography variant="body2" gutterBottom component="div">
                {row.notes ? row.notes : 'No Notes'}
              </Typography> */}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      })
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};

export default function OrderProducts(props) {
  const {
    status,
    handleUpdateStatus,
    orderProducts,
    handleOrderProdsNotes,
    couriersList,
    handleUpdateCourier,
    handleUpdateTracking,
  } = props;

  return (
    <TableContainer style={{ marginBottom: 24, maxHeight: 500 }}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell></TableCell>
            <TableCell align="left">Product</TableCell>
            <TableCell align="left">Quantity</TableCell>
            <TableCell align="left">Total Points</TableCell>
            <TableCell align="left">Order Date</TableCell>
            <TableCell align="left">Last Updated</TableCell>
            <TableCell align="left">Tracking URL</TableCell>
            <TableCell align="left">Update Status</TableCell>
            {/* <TableCell align="right">Remove</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {orderProducts.map((row) => (
            <Row
              status={status}
              handleUpdateStatus={handleUpdateStatus}
              handleUpdateCourier={handleUpdateCourier}
              handleUpdateTracking={handleUpdateTracking}
              key={row.name}
              row={row}
              handleOrderProdsNotes={handleOrderProdsNotes}
              couriersList={couriersList}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
